import React from 'react'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import { usePageView } from 'hooks'
import { getStaticWrapper, THEME, mapMediaDocToVideojsObject } from 'utils'
import { MediaStore } from 'stores/media'
import VideoPlayerLite from 'components/VideoPlayerLite'
import PageHeader from 'components/PartnershipsSite/PageHeader'

const PartnershipsPartners = ({ video }) => {
  usePageView()

  return (
    <PartnershipsLayout background='#D8D8D8' title=''>
      <div className='partners'>
        <PageHeader title={'OUR PARTNERS'} details='Be Everywhere with Barstool Sports' />
        <div className='partners__top'>
          <h1>Barstool moves the needle for our partners</h1>
          <h2>
            <span>1 in 3 Barstool fans</span> have made a purchase or used a promo code after hearing the brand on
            Barstool Sports
            <h3>(Source: Shareblee x Barstool Consumer Survey)</h3>
          </h2>
          <h2>
            Barstool audio ads drive an increase in purchase intent <span>2x</span> the Nielsen norm
            <h3>(Source: Nielsen)</h3>
          </h2>
        </div>
        {video && <VideoPlayerLite videoSource={mapMediaDocToVideojsObject(video)} />}
        <style jsx>{`
          .partners {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
          }
          .partners__top {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: ${THEME.COLORS.SECONDARY};
            color: #fff;
            padding: 30px 10px;
            text-align: center;
          }
          .partners__top h1 {
            font-size: 1.75rem;
            text-transform: uppercase;
            color: #fff;
          }
          .partners__top h2 {
            font-size: 1.2rem;
          }
          .partners__top h3 {
            font-size: 0.8rem;
          }
          .partners__top span {
            color: ${THEME.COLORS.PRIMARY};
          }
          @media (max-width: ${THEME.BREAKPOINTS.LG}px) {
            .partners__top {
              padding: 20px 10px;
            }
            .partners__top h1 {
              font-size: 1.25rem;
              line-height: 1.25;
            }
            .partners__top h2 {
              font-size: 0.8rem;
            }
            .partners__top h3 {
              font-size: 0.7rem;
            }
          }
          @media (max-width: ${THEME.BREAKPOINTS.SM - 1}px) {
            .partners__top h1 {
              font-size: 1.4rem;
              line-height: 1.25;
            }
            .partners__top h2 {
              font-size: 0.9rem;
            }
          }
        `}</style>
      </div>
    </PartnershipsLayout>
  )
}

export const getStaticProps = getStaticWrapper(async () => {
  try {
    const video = await MediaStore().findById('Nn4tHuELyLVngtSjskRROio9')
    return { video }
  } catch (e) {
    return { video: null }
  }
})

export default PartnershipsPartners
